"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPrefixedQuiltBundleId = buildPrefixedQuiltBundleId;
const assets_1 = require("@aurora/shared-types/assets");
const enums_1 = require("@aurora/shared-types/overrides/enums");
function buildBundleId(tenantId, pageId, node, lastModified) {
    return `${tenantId}:${pageId}:${node}-${lastModified !== null && lastModified !== void 0 ? lastModified : assets_1.LastModifiedKeys.DEFAULTS_ONLY}`;
}
/**
 * Builds an identifier to be used as an Apollo cache key for Quilt assets
 * @param tenantId tenant identifier from TenantContext
 * @param pageId page identifier
 * @param node context node identifier from AppContext
 * @param lastModified last modified timestamp
 */
function buildPrefixedQuiltBundleId(tenantId, pageId, node, lastModified) {
    return `${enums_1.CachedAssetType.QUILT}:${buildBundleId(tenantId, pageId, node, lastModified)}`;
}
//# sourceMappingURL=ApolloQuiltCacheHelper.js.map